/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
/*
 * Calculates the bounds this map would display at a given zoom level.
 * From: https://stackoverflow.com/a/4092928
 *
 * @member google.maps.Map
 * @method boundsAt
 * @param {Number}                 zoom         Zoom level to use for calculation.
 * @param {google.maps.LatLng}     [center]     May be set to specify a different center than the current map center.
 * @param {google.maps.Projection} [projection] May be set to use a different projection than that returned by this.getProjection().
 * @param {Element}                [div]        May be set to specify a different map viewport than this.getDiv() (only used to get dimensions).
 * @return {google.maps.LatLngBounds} the calculated bounds.
 *
 * @example
 * var bounds = map.boundsAt(5); // same as map.boundsAt(5, map.getCenter(), map.getProjection(), map.getDiv());
 */
if (typeof google !== 'undefined' && google != null && google.maps != null && google.maps.Map != null) { google.maps.Map.prototype.boundsAt = function(zoom, center, projection, div) {
  const p = projection || this.getProjection();
  if (!p) { return undefined; }
  const d = $(div || this.getDiv());
  const zf = Math.pow(2, (zoom + 1)) * 2;
  const dw = d.width() / zf;
  const dh = d.height() / zf;
  const cpx = p.fromLatLngToPoint(center || this.getCenter());
  return new google.maps.LatLngBounds(p.fromPointToLatLng(new google.maps.Point(cpx.x - dw, cpx.y + dh)),
                               p.fromPointToLatLng(new google.maps.Point(cpx.x + dw, cpx.y - dh)));
}; }